import React from 'react';
import PropTypes from 'prop-types';
import { VARIANTS, SIZES } from './Button.constants';
import { getIsDisabled, validateAriaLabel } from './Button.utils';
import { StyledButton, Content, IconSlot, Spinner } from './styled';

const Button = ({
  children = undefined,
  variant = VARIANTS.PRIMARY,
  size = SIZES.MD,
  disabled = false,
  isLoading = false,
  startIcon = null,
  endIcon = null,
  ariaLabel = undefined,
  className = '',
  ...rest
}) => {
  const isDisabled = getIsDisabled(disabled, isLoading);

  return (
    <StyledButton
      type="button"
      className={ className }
      variant={ variant }
      size={ size }
      isDisabled={ isDisabled }
      isLoading={ isLoading }
      disabled={ isDisabled }
      aria-label={ ariaLabel }
      aria-busy={ isLoading || undefined }
      { ...rest }
    >
      <Content isLoading={ isLoading }>
        {startIcon && <IconSlot>{startIcon}</IconSlot>}
        {children}
        {endIcon && <IconSlot>{endIcon}</IconSlot>}
      </Content>
      {isLoading && <Spinner aria-hidden="true" />}
    </StyledButton>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  size: PropTypes.oneOf(Object.values(SIZES)),
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  ariaLabel: validateAriaLabel,
  className: PropTypes.string
};

export default Button;
